const PurchaseResult = {
    OK : 'OK',
    INSUFFICIENT_FUNDS : 'INSUFFICIENT_FUNDS',
    MAX_LEVEL_REACHED : 'MAX_LEVEL_REACHED'
}

module.exports = PurchaseResult;